import { render, staticRenderFns } from "./client-overview.vue?vue&type=template&id=a018d0b8&scoped=true&"
import script from "./client-overview.vue?vue&type=script&lang=js&"
export * from "./client-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a018d0b8",
  null
  
)

export default component.exports